// A record's own text only makes a usable <meta name="description"> if it is long enough to describe the
// page (search engines rewrite very short ones, and "Ai Automation" is not a description). When it is
// too short, lead with the record's title so every page still gets a unique description, then add the
// page type's generic sentence. Never invents facts: the title is real data, the fallback is site copy.
const MIN_LENGTH = 50;
const MAX_LENGTH = 160;

export function ensureMetaDescription(text, title, fallback) {
  const plain = (text || "").replace(/\s+/g, " ").trim();
  if (plain.length >= MIN_LENGTH) return plain;

  const cleanTitle = (title || "").replace(/\s+/g, " ").trim();
  const combined = cleanTitle ? `${cleanTitle} - ${fallback}` : fallback;
  if (combined.length <= MAX_LENGTH) return combined;

  const cut = combined.slice(0, MAX_LENGTH - 1);
  const wordEnd = cut.lastIndexOf(" ");
  return (wordEnd > MAX_LENGTH * 0.5 ? cut.slice(0, wordEnd) : cut).replace(/[\s,;:\-]+$/, "") + "…";
}
